export const BRIDGE_CHANNEL = "circleOfDm.metaGame" as const;
export const BRIDGE_VERSION = 1 as const;

export type BridgeMessageType =
  | "setConfig"
  | "start"
  | "pause"
  | "ready"
  | "stateUpdate"
  | "error";

export interface BridgeEnvelope<TPayload = unknown> {
  channel: typeof BRIDGE_CHANNEL;
  version: typeof BRIDGE_VERSION;
  type: BridgeMessageType;
  requestId?: string;
  payload: TPayload;
}

export interface HostSetConfigPayload {
  roomId: string;
  apiBaseUrl: string;
  locale?: "ru" | "en";
  theme?: "light" | "dark";
}

export interface GameReadyPayload {
  gameVersion: string;
  capabilities: {
    postMessage: true;
    transport: "mock" | "server";
  };
}

